<app-header (toggleEvent)="toggleNav($event)"></app-header>
<div class="container-fluid sectionContainer p-0">
  <mat-sidenav-container class="example-container" [hasBackdrop]="false" autosize>
    <mat-sidenav
      #sidenav
      class="example-sidenav"
      mode="over"
      [(opened)]="sidenavToggle"
    >
      <app-mail-box *ngIf="sidenavToggle" (closeMailEvent)="toggleNav($event)"></app-mail-box>
    </mat-sidenav>
    <mat-sidenav-content class="sidenav_content_flex">
      <div class="card email_wrap box-shadow">
        <div class="row">
          <div class="col-md-4">
            <div class="card contact_wrap box-shadow">
              <div class="row">
                <div class="col-md-12 info_wrap">
                  <div class="contact_info">
                    <h3 class="MSB20">Contact Information</h3>
                    <p class="MM14">
                      Fill the Form and our team will get back to you within 24
                      hrs
                    </p>
                  </div>
                </div>
                <div
                  class="col-md-12 info_wrap"
                  style="padding-top: 0rem; font-weight: 600"
                >
                  <div class="contact_links">
                    <span class="MM16"
                      ><mat-icon style="color: #40dab2; vertical-align: middle"
                        >email</mat-icon
                      >
                      hello@truecover.net</span
                    >
                    <br />
                    <span class="MM16"
                      ><mat-icon style="color: #40dab2; vertical-align: middle"
                        >phone</mat-icon
                      >
                      91-7345667890</span
                    >
                    <br />
                    <span class="MM16"
                      ><mat-icon style="color: #40dab2; vertical-align: middle"
                        >place</mat-icon
                      >
                      Address</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 support_form" [formGroup]="emailSupportForm">
            <div class="row">
              <div class="col-md-6 column_wrap">
                <div class="form-group whitespace_fix">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label class="label-flex"
                      >Full Name <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Full Name"
                      formControlName="userName"
                    />
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['userName'].touched &&
                        emailSupportForm.controls['userName'].hasError(
                          'required'
                        )
                      "
                    >
                      Enter Full Name
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 column_wrap">
                <div class="form-group whitespace_fix">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label class="label-flex"
                      >Email <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Eg. example@abc.net"
                      formControlName="email"
                    />
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['email'].touched &&
                        emailSupportForm.controls['email'].hasError('required')
                      "
                    >
                      Enter Email
                    </mat-error>
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['email'].hasError('pattern')
                      "
                    >
                      Enter valid Email
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-6 column_wrap">
                <div class="form-group whitespace_fix">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label class="label-flex"
                      >Phone No. <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Eg. 8678656438"
                      formControlName="phoneNo"
                    />
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['phoneNo'].touched &&
                        emailSupportForm.controls['phoneNo'].hasError(
                          'required'
                        )
                      "
                    >
                      Enter Phone No.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['phoneNo'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Minimum 10 digits required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['phoneNo'].hasError(
                          'maxlength'
                        )
                      "
                    >
                      Maximum 10 digits required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls['phoneNo'].hasError('pattern')
                      "
                    >
                      Enter Valid Contact Number
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 column_wrap">
                <div class="form-group whitespace_fix">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label class="label-flex">Subject</mat-label>
                    <input
                      matInput
                      placeholder="Type the subject of your message"
                      formControlName="subject"
                    />
                    <!--<mat-error
                      *ngIf="
                        emailSupportForm.controls['subject'].touched &&
                        emailSupportForm.controls['subject'].hasError('required')
                      "
                    >
                      Enter Subject
                    </mat-error>-->
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 column_wrap">
                <div class="form-group whitespace_fix">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label class="label-flex"
                      >Message <span class="text-danger">*</span></mat-label
                    >
                    <textarea
                      matInput
                      placeholder="Please enter the details of your request here."
                      #address
                      formControlName="messageBody"
                    ></textarea>
                    <mat-error
                      *ngIf="
                        emailSupportForm.controls.messageBody.touched &&
                        emailSupportForm.controls.messageBody.hasError(
                          'required'
                        )
                      "
                    >
                      Enter Message
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="save_btn">
                  <button
                    mat-raised-button
                    color="primary"
                    [disabled]="!emailSupportForm.valid"
                    (click)="sendSupportMessage()"
                    class="save_changes"
                  >
                    Send Message
                  </button>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
